/** Workspace id from `/workspace/:workspaceId/...` routes. */
export function getWorkspaceIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/workspace\/([^/]+)/);
  return match?.[1] ?? null;
}

/**
 * Pick workspace on load: URL (what you're viewing) beats localStorage (last switch).
 * Prevents jumping to another workspace after tab sleep / reload.
 */
export function resolveInitialWorkspaceId(
  workspaces: Array<{ id: string }>,
  pathname: string = typeof window !== 'undefined' ? window.location.pathname : ''
): string | null {
  if (!workspaces.length) return null;

  const urlId = getWorkspaceIdFromPath(pathname);
  if (urlId && workspaces.some((w) => w.id === urlId)) {
    return urlId;
  }

  const savedId =
    typeof localStorage !== 'undefined' ? localStorage.getItem('currentWorkspaceId') : null;
  if (savedId && workspaces.some((w) => w.id === savedId)) {
    return savedId;
  }

  return workspaces[0].id;
}
